import styled from 'styled-components'

export const FlexView = styled.div`
  flex: ${(props) => props.size};
`
